import React from "react";
import { TableCell, Box, TextField, MenuItem } from "@mui/material";

// セル内の高さ・余白を揃えるための共通スタイル
const cellInnerSx = {
  minHeight: 40,
  display: "flex",
  alignItems: "center",
  width: "100%",
  px: 1,
  py: 0.5,
  boxSizing: "border-box",
};

export default function EditableTableCell({
  align = "left",
  value,
  displayValue,
  editing,
  type = "text",
  options = [],
  onStartEdit,
  onChange,
  onBlurSave,
  onKeyDown,
  disabled,
}) {
  const isCenter = align === "center";

  return (
    <TableCell
      align={isCenter ? "center" : "left"}
      sx={{ p: 0 }}
      onClick={() => {
        if (editing || disabled) return;
        onStartEdit?.(); // セルクリックで編集開始
      }}
    >
      <Box
        sx={{
          ...cellInnerSx,
          justifyContent: isCenter ? "center" : "flex-start",
          cursor: disabled ? "default" : "pointer",
          borderRadius: 1,
        }}
      >
        {editing ? (
          // select編集
          type === "select" ? (
            <TextField
              select
              variant="outlined"
              fullWidth
              autoFocus
              value={value ?? ""}
              onChange={(e) => onChange?.(e.target.value)}
              onBlur={onBlurSave}
              onKeyDown={onKeyDown}
              disabled={disabled}
              onClick={(e) => e.stopPropagation()}
              InputProps={{
                sx: {
                  fontSize: "inherit",
                  lineHeight: "inherit",
                  py: 0,
                },
              }}
              sx={{
                // 通常時は枠なし
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "1px solid transparent",
                },
                // フォーカス時だけ青い細枠
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "primary.main",
                    borderWidth: 1,
                  },
                // 高さ・余白を text と揃える
                "& .MuiSelect-select": {
                  py: 0,
                  px: isCenter ? 4 : 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: isCenter ? "center" : "flex-start",
                },
              }}
            >
              {options.map((o) => (
                <MenuItem
                  key={o.value}
                  value={o.value}
                  sx={{ justifyContent: isCenter ? "center" : "flex-start" }}
                >
                  {o.label}
                </MenuItem>
              ))}
            </TextField>
          ) : (
            // Text編集（inline編集用）
            <TextField
              variant="standard"
              fullWidth
              autoFocus
              value={value ?? ""}
              onChange={(e) => onChange?.(e.target.value)}
              onBlur={onBlurSave}
              onKeyDown={onKeyDown}
              disabled={disabled}
              onClick={(e) => e.stopPropagation()}
              InputProps={{
                disableUnderline: true,
                sx: { fontSize: "inherit", lineHeight: "inherit", py: 0 },
              }}
              sx={{ m: 0 }}
            />
          )
        ) : (
          // 表示モード
          displayValue ?? value ?? ""
        )}
      </Box>
    </TableCell>
  );
}
